import { useEffect, useState } from 'react'
import { Users, UserPlus, MessageCircle, Lock } from 'lucide-react'
import api from '../api/client'
import Loader from '../components/Loader'

const onlyDigits = (s) => (s || '').replace(/\D/g, '')

export default function ClientesRede() {
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(true)
  const [aba, setAba] = useState('diretos')

  useEffect(() => {
    api.get('/clientes/rede').then((r) => setData(r.data)).catch(() => setData({ diretos: [], indiretos: [] })).finally(() => setLoading(false))
  }, [])

  if (loading) return <div className="flex justify-center py-20"><Loader text="Carregando clientes..." /></div>
  const diretos = data?.diretos || []
  const indiretos = data?.indiretos || []

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between gap-3 flex-wrap">
        <div>
          <h1 className="text-2xl font-heading font-bold text-gray-900">Clientes</h1>
          <p className="text-sm text-gray-500 mt-0.5">Seus clientes diretos (dados completos) e os indiretos da sua rede (visão limitada por privacidade).</p>
        </div>
        <a href="#/cadastro/clientes" className="flex items-center gap-1.5 rounded-xl bg-gradient-to-r from-primary-500 to-accent-500 text-white px-4 py-2 text-sm font-semibold shadow"><UserPlus size={16} /> Novo cliente</a>
      </div>

      <div className="flex items-center gap-2">
        <button onClick={() => setAba('diretos')} className={`px-3 py-1.5 rounded-lg text-sm font-semibold ${aba === 'diretos' ? 'bg-gray-900 text-white' : 'bg-white border border-gray-200 text-gray-600'}`}>Diretos ({diretos.length})</button>
        <button onClick={() => setAba('indiretos')} className={`px-3 py-1.5 rounded-lg text-sm font-semibold ${aba === 'indiretos' ? 'bg-gray-900 text-white' : 'bg-white border border-gray-200 text-gray-600'}`}>Indiretos ({indiretos.length})</button>
      </div>

      {aba === 'diretos' ? (
        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-x-auto">
          <div className="px-4 py-3 font-heading font-semibold text-gray-900 flex items-center gap-2"><Users size={16} className="text-accent-600" /> Clientes Diretos</div>
          <table className="w-full text-sm">
            <thead className="bg-gray-50 text-gray-500 text-left text-xs uppercase tracking-wider">
              <tr><th className="px-4 py-2">Nome</th><th className="px-4 py-2">CPF/CNPJ</th><th className="px-4 py-2">E-mail</th><th className="px-4 py-2">Contato</th><th className="px-4 py-2">Produto/Serviço</th><th className="px-4 py-2">Cidade/UF</th><th className="px-4 py-2 text-right">Ação</th></tr>
            </thead>
            <tbody>
              {diretos.map((c) => (
                <tr key={c.id} className="border-t border-gray-100 hover:bg-primary-50/30">
                  <td className="px-4 py-2 font-medium text-gray-900">{c.nome}</td>
                  <td className="px-4 py-2 text-gray-500">{c.cpf_cnpj || '—'}</td>
                  <td className="px-4 py-2 text-gray-500">{c.email || '—'}</td>
                  <td className="px-4 py-2 text-gray-500">{c.telefone || '—'}</td>
                  <td className="px-4 py-2">{c.produto || '—'}</td>
                  <td className="px-4 py-2 text-gray-500">{[c.cidade, c.estado].filter(Boolean).join('/') || '—'}</td>
                  <td className="px-4 py-2 text-right">
                    {c.telefone && (
                      <a href={`https://wa.me/55${onlyDigits(c.telefone)}`} target="_blank" rel="noreferrer" title="Chamar no WhatsApp"
                        className="inline-flex items-center gap-1 text-emerald-600 hover:text-emerald-700 text-xs font-semibold"><MessageCircle size={15} /> WhatsApp</a>
                    )}
                  </td>
                </tr>
              ))}
              {diretos.length === 0 && <tr><td colSpan={7} className="px-4 py-8 text-center text-gray-400">Nenhum cliente direto.</td></tr>}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-x-auto">
          <div className="px-4 py-3 font-heading font-semibold text-gray-900 flex items-center gap-2"><Lock size={15} className="text-gray-400" /> Clientes Indiretos <span className="text-xs font-normal text-gray-400">(dados pessoais ocultos por privacidade/LGPD)</span></div>
          <table className="w-full text-sm">
            <thead className="bg-gray-50 text-gray-500 text-left text-xs uppercase tracking-wider">
              <tr><th className="px-4 py-2">Nome</th><th className="px-4 py-2">Produto/Serviço</th><th className="px-4 py-2">Cidade/UF</th><th className="px-4 py-2">Licenciado</th></tr>
            </thead>
            <tbody>
              {indiretos.map((c) => (
                <tr key={c.id} className="border-t border-gray-100">
                  <td className="px-4 py-2 font-medium text-gray-700">{c.nome}</td>
                  <td className="px-4 py-2">{c.produto || '—'}</td>
                  <td className="px-4 py-2 text-gray-500">{[c.cidade, c.estado].filter(Boolean).join('/') || '—'}</td>
                  <td className="px-4 py-2 text-gray-500">{c.licenciado || '—'}</td>
                </tr>
              ))}
              {indiretos.length === 0 && <tr><td colSpan={4} className="px-4 py-8 text-center text-gray-400">Nenhum cliente indireto na sua rede.</td></tr>}
            </tbody>
          </table>
        </div>
      )}
    </div>
  )
}
